import type { TenantContext, AnnouncementRepository } from '@zetyar/data-contracts'
import { createSupabaseAnnouncementRepository } from '@zetyar/supabase-client'
import { getSupabaseClient } from '@/infrastructure/supabase/app'

export const webAnnouncementRepository: AnnouncementRepository = createSupabaseAnnouncementRepository(getSupabaseClient())

export function createWebTenantContext(input: {
  readonly authUid: string
  readonly personId: string
  readonly organizationId: string
  readonly membershipId?: string
}): TenantContext {
  return input
}
